import { Stack } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { type FC } from "react";

interface IAppLoaderProps {
  byCenter?: boolean;
}

export const AppLoader: FC<IAppLoaderProps> = ({ byCenter }) => {
  if (byCenter) {
    return (
      <Stack
        sx={{
          width: "100%",
          alignItems: "center"
        }}>
        <CircularProgress />
      </Stack>
    );
  }

  return <CircularProgress />;
};
